import * as tslib_1 from "tslib";
import { css } from 'styled-components';
import Color from 'color';
import { getColorFromTheme } from '../utils/colors';
var getColor = function (props) {
    return getColorFromTheme(props, props.theme.typography.button.color);
};
export var getHoverBgColor = function (props) {
    var mainColor = getColor(props);
    if (mainColor && mainColor !== 'inherit' && mainColor !== 'currentColor') {
        return Color(mainColor)
            .alpha(0.12)
            .rgb()
            .string();
    }
    return null;
};
export default css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n  height: 36px;\n  line-height: 36px;\n  border-radius: 2px;\n  font-size: ", "rem;\n  font-weight: ", ";\n  font-family: ", ";\n  color: ", ";\n  user-select: none;\n  margin: ", "px;\n  transition: background-color 100ms ease-in-out;\n  padding: 0px 16px;\n\n  overflow: hidden;\n  position: relative;\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  ", ";\n  height: 36px;\n  line-height: 36px;\n  border-radius: 2px;\n  font-size: ",
    "rem;\n  font-weight: ",
    ";\n  font-family: ",
    ";\n  color: ", ";\n  user-select: none;\n  margin: ", "px;\n  transition: background-color 100ms ease-in-out;\n  padding: 0px 16px;\n\n  overflow: hidden;\n  position: relative;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) { return (props.autoWidth ? '' : 'min-width: 88px'); }, function (props) {
    return props.theme.typography.button.fontSize;
}, function (props) {
    return props.theme.typography.button.fontWeight;
}, function (props) {
    return props.theme.typography.button.fontFamily;
}, getColor, function (props) { return props.theme.spacing.unit; }, getHoverBgColor);
var templateObject_1;
//# sourceMappingURL=FlatButtonStyle.js.map